export const GET_ORGANIZATION_MOBILE_USERS = 'GET_ORGANIZATION_MOBILE_USERS'
export const CLEAR_ORGANIZATION_MOBILE_USERS = 'CLEAR_ORGANIZATION_MOBILE_USERS'
export const CREATE_ORGANIZATION_MOBILE_USER = 'CREATE_ORGANIZATION_MOBILE_USER'
export const UPDATE_ORGANIZATION_MOBILE_USER = 'UPDATE_ORGANIZATION_MOBILE_USER'
export const FETCH_ORGANIZATION_MOBILE_USERS = 'FETCH_ORGANIZATION_MOBILE_USERS'
export const SUCCESS_ORGANIZATION_MOBILE_USERS =
  'SUCCESS_ORGANIZATION_MOBILE_USERS'
export const ERROR_ORGANIZATION_MOBILE_USERS = 'ERROR_ORGANIZATION_MOBILE_USERS'
export const DELETE_ORGANIZATION_MOBILE_USER = 'DELETE_ORGANIZATION_MOBILE_USER'
